<template>
    <div>
        <transition name='fade' mode="out-in">
            <div v-if='show_out_of_stock_message' class='out-of-stock'>
                <div v-if='stock.left_in_stock > 0'>
                    There are only {{stock.left_in_stock}} of this item left in stock
                </div>
                <div v-if='stock.left_in_stock == 0'>
                    This item is out of stock
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props:{
        stock:{
            default:{
                left_in_stock: 0,
                in_stock: true
            }
        }
    },
    data(){
        return{
            show_out_of_stock_message: false
        }
    },
    methods:{
        showOutOfStock(){
            this.show_out_of_stock_message = true;

            setTimeout(() => {
                 this.show_out_of_stock_message = false;
            }, 2000);
        }
    },
    watch:{
        'stock': function(){
            if(this.stock.in_stock == false){
                this.showOutOfStock();
            }
            else{
                this.show_out_of_stock_message = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
// .out-of-stock{
//     border-radius: 2px;
//     padding: 20px 50px;
//     width: 200px;
//     // border: solid 1px #868e96;
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     background-color: #ffe3e3;
//     position: absolute;
//     // left: 0;
// }
</style>